// extracted by mini-css-extract-plugin
module.exports = {"recommend":"_1986","title":"_10599","list":"_11801"};